import { useViewerQuery } from "../viewerQuery";
import { useSetFlag } from "./setFlag";
import { FlagName } from "./userFlagsModel";
import { useCallback, useRef } from "react";
import { getABTestOverride } from "./useABTest";

// return one of three states:
// 1. undefined: user is not in the test group
// 2. true: user is in on test group
// 3. false: user is in off test group

export const useCreateABTest = (testName: FlagName): (() => boolean | undefined) => {
  const { getFlag, isSubscriber } = useViewerQuery();
  const setFlag = useSetFlag();
  const abtest = getFlag(testName);
  const alreadyExists = !!abtest;
  const willBeOn = useRef<boolean>(Math.random() < 0.5);
  const created = useRef<boolean>(false);

  return useCallback(() => {
    // Check if override is set (for testing purposes)
    const override = getABTestOverride();
    if (override !== null) {
      return override;
    }

    if (!alreadyExists && !created.current && !isSubscriber) {
      created.current = true;
      setFlag({
        name: testName,
        value: willBeOn.current ? "on" : "off"
      });
    }

    return alreadyExists ? abtest.value === "on" : isSubscriber ? undefined : willBeOn.current;
  }, [alreadyExists, isSubscriber, setFlag, testName, abtest?.value]);
};
